<mat-card class="default-card grid-all">
    <mat-card-header>
        <mat-card-title>{{ data.title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <form class="form-container" #dialogForm="ngForm">
                <mat-form-field>
                    <mat-select data-select-attribute-name placeholder="Attribut" [(value)]="attributeId" tabindex="1" (selectionChange)="onSelectedAttributeChange($event)">
                        @for (attribute of data.attributes; track attribute) {
                            <mat-option data-select-listing-attribute-name-option [value]="attribute.id">
                                {{ attribute.header }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                @if (!!selectedAttribute) {
                    @if (selectedAttribute.type === PropertyType.List || selectedAttribute.type === PropertyType.ListCustomers || selectedAttribute.name === 'FolderStateId') {
                        <mat-form-field>
                            <mat-select placeholder="Valeur" [(value)]="attributeValue" tabindex="2">
                                @for (item of listValues; track item.value) {
                                    <mat-option [value]="item.value">
                                        {{ item.text }}
                                    </mat-option>
                                }
                            </mat-select>

                            @if (listAttributeValueCtrl.hasError('required')) {
                                <mat-error>Une valeur est obligatoire</mat-error>
                            }
                        </mat-form-field>
                    } @else if (selectedAttribute.type === PropertyType.Color) {
                        <!-- Affichage d'un attribut de type 'Couleur' -->
                        <mat-form-field class="with-info-icon">
                            <mat-select placeholder="Valeur" [(value)]="attributeValue" tabindex="2" ngClass="bak-{{ attributeValue }}-color">
                                <mat-option value="">Aucune</mat-option>
                                <mat-option class="mat-option-green-color" value="green"></mat-option>
                                <mat-option class="mat-option-orange-color" value="orange"></mat-option>
                                <mat-option class="mat-option-red-color" value="red"></mat-option>
                                <mat-option class="mat-option-grey-color" value="grey"></mat-option>
                                <mat-option class="mat-option-light-blue-color" value="lightBlue"></mat-option>
                                <mat-option class="mat-option-dark-blue-color" value="darkBlue"></mat-option>
                            </mat-select>
                            @if (listAttributeValueCtrl.hasError('required')) {
                                <mat-error>Une valeur est obligatoire</mat-error>
                            }
                        </mat-form-field>
                    } @else if (selectedAttribute.type === PropertyType.Long || selectedAttribute.type === PropertyType.Decimal) {
                        <mat-form-field>
                            <input
                                matInput
                                data-input-name
                                type="number"
                                placeholder="Valeur"
                                [(ngModel)]="attributeValue"
                                name="attributeValue"
                                required
                                autocomplete="false"
                                tabindex="2" />
                            @if (inputCtrl.hasError('required')) {
                                <mat-error>Une valeur est obligatoire</mat-error>
                            }
                        </mat-form-field>
                    } @else if (selectedAttribute.type === PropertyType.Date) {
                        <mat-form-field>
                            <input
                                matInput
                                data-input-name
                                [matDatepicker]="picker"
                                placeholder="Valeur"
                                [(ngModel)]="attributeValue"
                                name="attributeValue"
                                required
                                autocomplete="false"
                                tabindex="2" />
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                            @if (inputCtrl.hasError('required')) {
                                <mat-error>Une valeur est obligatoire</mat-error>
                            }
                        </mat-form-field>
                    } @else if (selectedAttribute.type === PropertyType.DateAndTime) {
                        <mat-form-field>
                            <input
                                matInput
                                data-input-name
                                [ngxMatDatetimePicker]="timePicker"
                                placeholder="Valeur"
                                [(ngModel)]="attributeValue"
                                name="attributeValue"
                                required
                                autocomplete="false"
                                tabindex="2" />
                            <mat-datepicker-toggle matSuffix [for]="timePicker"></mat-datepicker-toggle>
                            <ngx-mat-datetime-picker #timePicker></ngx-mat-datetime-picker>
                            @if (inputCtrl.hasError('required')) {
                                <mat-error>Une valeur est obligatoire</mat-error>
                            }
                        </mat-form-field>
                    } @else if (selectedAttribute.type === PropertyType.Email) {
                        <mat-form-field>
                            <input
                                matInput
                                data-input-name
                                type="text"
                                placeholder="Valeur"
                                [(ngModel)]="attributeValue"
                                [formControl]="inputCtrl"
                                autocomplete="false"
                                tabindex="2" />
                            @if (inputCtrl.hasError('required')) {
                                <mat-error>Une valeur est obligatoire</mat-error>
                            }
                            @if (inputCtrl.invalid) {
                                <mat-error>Adresse email non valide</mat-error>
                            }
                        </mat-form-field>
                    } @else if (selectedAttribute.type === PropertyType.PhoneNumber) {
                        <mat-form-field>
                            <input
                                matInput
                                data-input-name
                                type="text"
                                placeholder="Valeur"
                                [(ngModel)]="attributeValue"
                                [formControl]="inputCtrl"
                                autocomplete="false"
                                tabindex="2" />
                            @if (inputCtrl.hasError('required')) {
                                <mat-error>Une valeur est obligatoire</mat-error>
                            }
                            @if (inputCtrl.invalid) {
                                <mat-error>N° de téléphone non valide</mat-error>
                            }
                        </mat-form-field>
                    } @else if (selectedAttribute.type === PropertyType.AutocompletionByApi) {
                        <mat-form-field>
                            <input matInput placeholder="Valeur" type="text" [formControl]="listAttributeValueCtrl" [matAutocomplete]="auto" />
                            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (closed)="onAutocompleteClosed()" (optionSelected)="onAutocompleteItemSelected($event)">
                                <mat-option *ngFor="let autocompletionValue of autocompletionValues | async" [value]="autocompletionValue">{{ autocompletionValue }}</mat-option>
                            </mat-autocomplete>
                            @if (listAttributeValueCtrl.hasError('required')) {
                                <mat-error>Une valeur est obligatoire</mat-error>
                            }
                        </mat-form-field>
                    } @else {
                        <mat-form-field>
                            <input
                                matInput
                                data-input-name
                                type="text"
                                placeholder="Valeur"
                                [(ngModel)]="attributeValue"
                                [formControl]="inputCtrl"
                                required
                                autocomplete="false"
                                tabindex="2" />
                            @if (inputCtrl.hasError('required')) {
                                <mat-error>Une valeur est obligatoire</mat-error>
                            }
                        </mat-form-field>
                    }
                }

                <mat-form-field>
                    <input
                        matInput
                        data-input-name
                        type="text"
                        placeholder="Format"
                        [(ngModel)]="attributeFormat"
                        name="attributeFormat"
                        autocomplete="false"
                        [disabled]="formatDisabled"
                        tabindex="3" />
                </mat-form-field>
            </form>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="onDismiss()">Annuler</button>
        <button mat-raised-button class="accent-button" (click)="onConfirm()">Valider</button>
    </mat-card-actions>
</mat-card>
